import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, computed, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { checkMobile } from '../../utils/utils'
import { ROUTER_NAME } from '../../router'
import { LETTER_FORMAT } from '../../utils/constants'
import ExamResultMobile from '../atoms_molecules/ExamResultMobile.vue'
import { GroupQuestion } from '../../../api/v2/models/question'
import ExamResultQuestionGroupList from '../atoms_molecules/ExamResultQuestionGroupList.vue'
import { headerState } from '../../stores/header'
import { examResultState } from '../../stores/exam_result'
import { getQueryString } from '../../../../helpers/route-helper'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamResultQuestionList',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const mobile = ref(false)

const exam = computed(() => examResultState.examResult)
const groupQuestions = computed((): GroupQuestion[] => examResultState.groupQuestions)
const redirectNotFoundPage = computed(() => examResultState.redirectNotFoundPage)
const examQScoreHistory = computed(() => examResultState.examQScoreHistory)

const userExamId = computed(() => getQueryString(route.query, 'user_exam_id'))

const userExam = computed(() => {
  if (userExamId.value) {
    return exam.value?.userExams?.find((userExam) => `${userExam.id}` == userExamId.value)
  }
  return exam.value?.userExam
})

const back = () => {
  router.push({
    name: ROUTER_NAME.EXAM_RESULT,
    params: { examId: route.params.examId as string },
    query: route.query
  })
}

const redirectToNotFoundPage = () => {
  router.push({ name: ROUTER_NAME.NOT_FOUND })
}

const gotoTop = () => {
  router.push({ name: ROUTER_NAME.MY_EXAM_LIST })
}

const getQuestionNumber = (groupExamResultQuestion: GroupQuestion) => {
  return (
    groupQuestions.value
      .filter((item) => item.questions.every((question) => !question.isDescriptionQuestion))
      .indexOf(groupExamResultQuestion) + 1
  )
}

watch(() => route, () => {
  examResultState.requestExamResult(parseInt(route.params.examId as string))
  examResultState.requestExamQScoreHistories(parseInt(route.params.examId as string))
}, { immediate: true })

watch(redirectNotFoundPage, (val) => {
  if (val) {
    examResultState.setRedirectNotFoundPage({ status: false })
    redirectToNotFoundPage()
  }
})

onMounted(() => {
  mobile.value = checkMobile()
  headerState.setTitle('問題一覧')

  if (groupQuestions.value.length == 0) {
    examResultState.requestExamResult(parseInt(route.params.examId as string)).then(() => {
      examResultState.setUserExamId(Number(userExamId.value))
      examResultState.getExamResultQuestions()
      examResultState.requestExamGroupQuestion(Number(route.params.questionId))
      examResultState.requestExamQScoreHistories(parseInt(route.params.examId as string))
    })
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (exam.value)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "exam-final-screen pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            justify: "center",
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    class: "report-list",
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupQuestions.value, (item, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: index + 'group'
                        }, [
                          _createVNode(ExamResultQuestionGroupList, {
                            item: item,
                            questionNumber: getQuestionNumber(item),
                            padding: true,
                            exam: exam.value,
                            "user-exam": userExam.value,
                            examQScoreHistory: examQScoreHistory.value
                          }, null, 8 /* PROPS */, ["item", "questionNumber", "exam", "user-exam", "examQScoreHistory"]),
                          (index + 1 < groupQuestions.value.length)
                            ? (_openBlock(), _createBlock(_component_v_divider, {
                                key: index + 'group_divider'
                              }))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}
}

})